import { h } from 'preact';
import { useCallback, useContext } from 'preact/hooks';
import { ItemsContext } from './ItemsProvider';

const PriceTag = () => {
  const { state } = useContext(ItemsContext);
  const { items } = state;

  const price = useCallback(() => {
    const newPrice = items.reduce((acc, curr) => {
      return (
        acc +
        curr.variant.price * curr.quantity * (curr.variant.available ? 1 : 0)
      );
    }, 0);
    const formattedPrice = (newPrice / 100).toFixed(2);
    return formattedPrice;
  }, [items]);

  return (
    <div className="price-box">
      <span className="price">
        <span className="shopify-Price-amount amount">
          <span className="money" style={{ fontSize: '22px', fontWeight: 600 }}>
            ${price()}
          </span>
        </span>
      </span>
    </div>
  );
};

export default PriceTag;
